module.exports = __webpack_public_path__ + "img/Phylogenetic_trees_1.8f5d0145.jpg";